import gql from 'graphql-tag';

export const GET_VOTERS_TAGS = gql`
  query GetVoterTags($orgId: Int!, $voterId: Int!) {
    ri_apps_prd_org_voter_tags(
      where: { _and: [{ organization_id: { _eq: $orgId } }, { voter_id: { _eq: $voterId } }] }
    ) {
      org_voter_tag_id
      org_voter_tags_c_tag {
        c_tag_id
        title
      }
      org_voter_tags_org_tag {
        org_tag_id
        title
      }
    }
  }
`;

export const GET_VOTERS_TAGS_FOR_SUPERADMIN = gql`
  query GetVoterTagsForSuperadmin($voterId: Int!, $orgTypeId: Int!) {
    ri_apps_prd_org_voter_tags(
      where: {
        voter_id: { _eq: $voterId }
        org_voter_tags_organization: { organization_type_id: { _eq: $orgTypeId } }
      }
    ) {
      org_voter_tag_id
      org_voter_tags_c_tag {
        c_tag_id
        title
      }
      org_voter_tags_org_tag {
        org_tag_id
        title
      }
    }
  }
`;

export const GET_ALL_TAGS = gql`
  query GetAllTags($orgId: Int!) {
    ri_apps_prd_c_tags {
      c_tag_id
      title
    }
    ri_apps_prd_org_tags(where: { organization_id: { _eq: $orgId } }) {
      org_tag_id
      title
    }
  }
`;

export const CREATE_VOTER_TAGS = gql`
  mutation CreateOrgVoterTag($data: ri_apps_prd_org_voter_tags_insert_input!) {
    insert_ri_apps_prd_org_voter_tags(objects: [$data]) {
      affected_rows
    }
  }
`;

export const DELETE_VOTER_C_TAG = gql`
  mutation DeleteVoterOrgCTag($orgId: Int!, $voterId: Int!, $cTagId: Int) {
    delete_ri_apps_prd_org_voter_tags(
      where: {
        _and: [
          { organization_id: { _eq: $orgId } }
          { voter_id: { _eq: $voterId } }
          { c_tag_id: { _eq: $cTagId } }
        ]
      }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_VOTER_ORG_TAG = gql`
  mutation DeleteVoterOrgOrgTag($orgId: Int!, $voterId: Int!, $orgTagId: Int) {
    delete_ri_apps_prd_org_voter_tags(
      where: {
        _and: [
          { organization_id: { _eq: $orgId } }
          { voter_id: { _eq: $voterId } }
          { org_tag_id: { _eq: $orgTagId } }
        ]
      }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_VOTER_ORG_TAGS = gql`
  mutation DeleteVoterOrgTags(
    $orgId: Int!
    $voterId: Int!
    $tags_filter: ri_apps_prd_org_voter_tags_bool_exp!
  ) {
    delete_ri_apps_prd_org_voter_tags(
      where: {
        _and: [{ organization_id: { _eq: $orgId } }, { voter_id: { _eq: $voterId } }, $tags_filter]
      }
    ) {
      affected_rows
    }
  }
`;

export const GET_VOTERS_TAGS_FOR_ORGANIZATION = gql`
  query GetVoterTags($where: ri_apps_prd_org_voter_tags_bool_exp) {
    ri_apps_prd_org_voter_tags(where: $where) {
      org_voter_tag_id
      voter_id
      org_voter_tags_c_tag {
        c_tag_id
        title
      }
      org_voter_tags_org_tag {
        org_tag_id
        title
      }
    }
  }
`;

export const UPSERT_ORG_VOTER_C_TAGS = gql`
  mutation UpsertOrgVoterTags($objects: [ri_apps_prd_org_voter_tags_insert_input!]!) {
    insert_ri_apps_prd_org_voter_tags(
      objects: $objects
      on_conflict: {
        constraint: org_voter_tags_voter_id_organization_id_c_tag_id_key
        update_columns: []
      }
    ) {
      affected_rows
    }
  }
`;

export const BULK_CREATE_VOTER_TAGS = gql`
  mutation BulkCreateVoterTags($data: [ri_apps_prd_org_voter_tags_insert_input!]!) {
    insert_ri_apps_prd_org_voter_tags(objects: $data) {
      affected_rows
      returning {
        org_voter_tag_id
        voter_id
        org_voter_tags_c_tag {
          c_tag_id
          title
        }
        org_voter_tags_org_tag {
          org_tag_id
          title
        }
      }
    }
  }
`;
